import { useCallback, useEffect, useState } from 'react';

function useActiveSpeaker({ zoomClient }) {
  const [speakingUsers, setSpeakingUsers] = useState([]);
  const activeSpeaker = useCallback(payload => {
    setSpeakingUsers(payload);
    setTimeout(() => {
      setSpeakingUsers([]);
    }, 1000);
  }, []);

  useEffect(() => {
    if (!zoomClient) return;
    zoomClient.on('active-speaker', activeSpeaker);
    return () => {
      zoomClient.off('active-speaker', activeSpeaker);
    };
  }, [activeSpeaker, zoomClient]);

  return { speakingUsers };
}

export default useActiveSpeaker;
